import { addLastPrefixSA } from '../transforms/addLastPrefix';
import { formatOrdinalSA } from '../transforms/formatOrdinal';
import { overrideBaseLocale } from './base-config';
export var heIL = overrideBaseLocale('he-IL', {
    dayOfMonthOrdinal: {
        options: {
            day: 'numeric',
        },
        transforms: [formatOrdinalSA],
    },
    dayOfMonth: {
        options: {
            day: 'numeric',
        },
        transforms: [addLastPrefixSA],
    },
});
//# sourceMappingURL=he-IL.js.map